module.exports = __webpack_public_path__ + "static/media/k12_flyers.ae5f3684.jpg";